import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/reset.css";
import "./assets/fonts/iconfont/iconfont.css";
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
import 'animate.css';
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.prototype.$baseUrl = "";
Vue.prototype.$toPathUrl = "/admin/";

Vue.use(ElementUI);
Vue.use(Antd);
//dd
Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false;

function setMetaAttribute(selector, attribute, value) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    const match = selector.match(/meta\[(name|property)="([^"]+)"\]/);
    if (match) {
      tag.setAttribute(match[1], match[2]);
    }
    document.head.appendChild(tag);
  }
  tag.setAttribute(attribute, value);
}

function setCanonical(url) {
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", url);
}

function updateSeo(meta = {}) {
  if (!meta.title) return;
  document.title = meta.title;
  setMetaAttribute('meta[name="description"]', "content", meta.description || "");
  setMetaAttribute('meta[name="keywords"]', "content", meta.keywords || "");
  setMetaAttribute('meta[property="og:title"]', "content", meta.title);
  setMetaAttribute('meta[property="og:description"]', "content", meta.description || "");
  setMetaAttribute('meta[property="og:url"]', "content", meta.canonical || window.location.href);
  setCanonical(meta.canonical || window.location.href);
}

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach((to) => {
  updateSeo(to.meta);
});

new Vue({
  router,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
}).$mount("#app");
